/*
  Delivery estimate.

  Turns a transit window into a date a person can picture. Orders placed after
  the cut-off, and orders placed at the weekend, roll to the next working day;
  transit itself is counted in working days too. Formatting goes through Intl
  with the page's own language, so the date reads natively in each market.
*/
class PocketroDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const target = this.querySelector('[data-delivery-target]');
    const template = this.dataset.template;
    if (!target || !template) return;

    const transitMax = parseInt(this.dataset.transitMax, 10);
    if (!Number.isFinite(transitMax)) return;

    const cutoffHour = parseInt(this.dataset.cutoffHour, 10);
    const leadDays = parseInt(this.dataset.leadDays, 10) || 0;

    const dispatch = this.nextWorkingDay(new Date(), {
      rollToTomorrow: Number.isFinite(cutoffHour) && new Date().getHours() >= cutoffHour,
      extraDays: leadDays,
    });

    const arrival = this.addWorkingDays(dispatch, transitMax);
    const locale = document.documentElement.lang || undefined;

    let formatted;
    try {
      formatted = new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
      }).format(arrival);
    } catch (error) {
      return; // Keep the server-rendered range rather than show a wrong date.
    }

    target.textContent = template.replace('%%DATE%%', formatted);
  }

  nextWorkingDay(date, { rollToTomorrow, extraDays }) {
    const result = new Date(date);
    if (rollToTomorrow) result.setDate(result.getDate() + 1);
    for (let i = 0; i < extraDays; i += 1) result.setDate(result.getDate() + 1);
    while (result.getDay() === 0 || result.getDay() === 6) {
      result.setDate(result.getDate() + 1);
    }
    return result;
  }

  addWorkingDays(date, days) {
    const result = new Date(date);
    let remaining = days;
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) remaining -= 1;
    }
    return result;
  }
}

if (!customElements.get('pocketro-delivery-estimate')) {
  customElements.define('pocketro-delivery-estimate', PocketroDeliveryEstimate);
}
